import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material"
import { Fragment, useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { FormProvider, useForm } from "react-hook-form"
import { useOrgDivOptions } from "@hooks/useOrgDivOptions"
import { getAddProductFormFields } from "./const"
import { FormBuilder } from "@components/FormBuilder"
import { AddProductDto } from "@custom-types/products"
import { useAddProductMutation } from "@store/services/productsService"
import SuccessDialog from "@components/SuccessDialog"
import { GenericForm } from "@custom-types/form"

export const AddProduct = () => {
  const navigate = useNavigate()
  const formMethods = useForm<AddProductDto>({
    defaultValues: {
      name: "",
      organisation_key: "",
      division_key: "",
      description: "",
      active: true,
      is_external: false,
    },
  })
  const watchedOrganisationKey = formMethods.watch("organisation_key")
  const { organisationOptions, divisionOptions } = useOrgDivOptions(watchedOrganisationKey)
  const [addProduct, { data: addProductData }] = useAddProductMutation()
  const [productFormFields, setProductFormFields] = useState<GenericForm>({})

  const onSubmit = (data: AddProductDto) => addProduct(data)

  const onCancelClickHandler = () => navigate("/Administration/Products")

  useEffect(() => {
    setProductFormFields(getAddProductFormFields({ organisationOptions, divisionOptions }))
  }, [organisationOptions, divisionOptions])

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Add Product Form
      </Typography>
      {productFormFields ? (
        <FormProvider {...formMethods}>
          <form autoComplete="off" onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container spacing={2} alignItems="center">
              {Object.entries(productFormFields).map(([fieldName, fieldComponent]) => (
                <Fragment key={fieldName}>
                  <FormBuilder field={fieldName} component={fieldComponent} />
                </Fragment>
              ))}
              <Grid item xs={12} sx={{ mt: 4 }}>
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button
                  sx={{ ml: 1 }}
                  variant="contained"
                  color="error"
                  type="button"
                  onClick={onCancelClickHandler}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      )}
      <SuccessDialog
        open={!!addProductData}
        onCloseClick={() => navigate("/Administration/Products")}
      />
    </Box>
  )
}
